// export const API_URL = "http://localhost:8000/api/"
export const API_URL = "https://azcool2.net/api/"
